import { agent, API_MAP } from 'helpers';

import type { ICDFItems, ICDFList, IFilterParams } from './interfaces';

export default class CDFServices {
  static getList(params: IFilterParams) {
    return agent.get<ICDFList>(API_MAP.cdfList, {
      ...params,
      received_at: params.received_at ? params.received_at.format('YYYY-MM-DD') : null,
      received_at_final: params.received_at_final ? params.received_at_final.format('YYYY-MM-DD') : null,
    });
  }

  static getDetailsItems(id: number) {
    return agent.get<ICDFItems>(API_MAP.cdfDetailsItems.replace('{id}', id.toString()));
  }

  static getDetailsFiles(id: number) {
    return agent.get<ICDFItems>(API_MAP.cdfDetailsFiles.replace('{id}', id.toString()));
  }

  static urlDownload(id: number) {
    return agent.get(API_MAP.cdfUrlDownload.replace('{id}', id.toString()));
  }

  static export(params: IFilterParams) {
    return agent.get(API_MAP.exportCDF, {
      ...params,
      received_at: params.received_at ? params.received_at.format('YYYY-MM-DD') : null,
      received_at_final: params.received_at_final ? params.received_at_final.format('YYYY-MM-DD') : null,
    });
  }
}
